import { render } from "./dropdown-items.vue?vue&type=template&id=2fe47682"
import script from "./dropdown-items.vue?vue&type=script&lang=js"
export * from "./dropdown-items.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Personal\\SEV\\Projekt\\Backend\\sev-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__